import { render } from "./OrdersTerminal.vue?vue&type=template&id=03a65479&scoped=true"
import script from "./OrdersTerminal.vue?vue&type=script&lang=js"
export * from "./OrdersTerminal.vue?vue&type=script&lang=js"

import "./OrdersTerminal.vue?vue&type=style&index=0&id=03a65479&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a65479"]])

export default __exports__